module.exports = __webpack_public_path__ + "static/img/a-1.82042def.png";